<template>
   <div>
      <h1 class="text-3xl font-bold mb-3 mt-10">Asiakaspalautelomake</h1>

      <label for="role">Palautteen antaja</label>
      <button v-bind:class="{'is-active': isSelected('sender', 'customer')}" @click="setValue('sender', 'customer')" class="btn"> Asiakas </button>
      <button v-bind:class="{'is-active': isSelected('sender', 'staff')}" @click="setValue('sender', 'staff')" class="btn"> Henkilökunnan jäsen </button>
      <button v-bind:class="{'is-active': isSelected('sender', 'other')}" @click="setValue('sender', 'other')" class="btn"> Muu </button>

      <div>
         <label for="house">Päiväkoti</label>
         <input v-model="payload.house" type="text" id="house" placeholder="Päiväkodin nimi" />
      </div>

      <div>
         <label for="feedback">Palautteesi</label>
         <div>
            <textarea v-model="payload.feedback" id="feedback" name="" cols="30" rows="5"></textarea>
         </div>
      </div>

      <div >
         <label for="returning">Aiotko käyttää palveluitamme jatkossakin?</label>
         <button v-bind:class="{'is-active': isSelected('returning', true)}" @click="setValue('returning', true)" class="btn"> Kyllä </button>
         <button v-bind:class="{'is-active': isSelected('returning', false)}" @click="setValue('returning', false)" class="btn"> Ei </button>
      </div>

      <div>
         <label for="contact">Toivon, että minuun otetaan yhteyttä</label>
         <button v-bind:class="{'is-active': isSelected('contact', 'phone')}" @click="setValue('contact', 'phone')" class="btn"> Puhelimitse </button>
         <button v-bind:class="{'is-active': isSelected('contact', 'email')}" @click="setValue('contact', 'email')" class="btn"> Sähköpostitse </button>
         <button v-bind:class="{'is-active': isSelected('contact', 'none')}" @click="setValue('contact', 'none')" class="btn"> En halua yhteydenottoa </button>
      </div>

      <div>
         <label>Nimi</label>
         <div>
            <input v-model="payload.name" type="text" id="name" />
         </div>
      </div>

      <div>
         <label>Puhelin</label>
         <div>
            <input v-model="payload.phone" type="phone" id="phone" />
         </div>
      </div>

      <div>
         <label>Sähköposti</label>
         <div>
            <input v-model="payload.email" type="email" id="email" />
         </div>
      </div>

      <p class="text-gray-900 mt-5 mb-3">Voit jättää palautteen myös anonyymisti. Huomioithan, että tällöin emme voi ottaa sinuun yhteyttä.</p>

      <p class="text-gray-900 mt-3 mb-5">Tällä lomakkeella kerätään henkilötietojasi asiakaspalvelun mahdollistamiseksi.</p>

      <button @click="submit()" class="btn" type="submit" id="send">Lähetä palaute</button>
   </div>
</template>

<script>
import Axios from 'axios'

export default {
   name: 'app',

   props: ['store'],

   data () {
      return {
         payload: {
            sender: null,
            returning: null,
            contact: null
         }
      }
   },

   components: {
   },

   methods: {
      setValue (prop, val) {
         this.payload[prop] = val
      },

      isSelected (prop, val) {
         return this.payload[prop] === val
      },

      submit () {
         Axios.post(process.env.VUE_APP_API_URL + '/api/public/v1/inbound/feedback', this.payload).then(
            function (success) { console.log(success) },
            function (error) { console.error(error) }
         )

         this.store.state.sent = true
      }
   },

   computed: {
   }
}
</script>
